import { render, staticRenderFns } from "./customFunction2.vue?vue&type=template&id=476eea46"
import script from "./customFunction2.vue?vue&type=script&lang=js"
export * from "./customFunction2.vue?vue&type=script&lang=js"
import style0 from "./customFunction2.vue?vue&type=style&index=0&id=476eea46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports